<mat-chip-grid #associationGrid aria-label="Associations">
  @for (association of editableAssociations(); track association; let first = $first) {
    @if (first || showAdditionalChips) {
      <mat-chip-row
        (removed)="handleRemoveOption(association)"
        (mousedown)="$event.preventDefault()"
        matTooltip="{{ association.name }}"
      >
        {{ association.name | crmTruncate }}
        @if (association.crmObjectId !== fixedId) {
          <button matChipRemove [attr.aria-label]="'remove ' + association.name">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
  }
  @if (editableAssociations().length > 1 && !showAdditionalChips) {
    <mat-chip>
      {{ editableAssociations().length - 1 }}
      more
    </mat-chip>
  }

  @if (useAssociationFormFields()) {
    <input
      [placeholder]="placeholder"
      [matChipInputFor]="associationGrid"
      readonly
      (click)="openAssociationFormModal()"
    />
  } @else {
    <input
      [placeholder]="placeholder"
      [matChipInputFor]="associationGrid"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
      [formControl]="searchCtrl"
      (focus)="showAdditionalChips = true"
      (blur)="showAdditionalChips = false"
    />
  }
</mat-chip-grid>
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="handleSelectOption($event)">
  @for (option of options(); track option.crmObjectId) {
    <mat-option [value]="option">
      <span class="name">{{ option.name }}</span>
      <span class="association-info">{{ option.associationInfo }}</span>
    </mat-option>
  }
</mat-autocomplete>
